/* eslint-disable no-useless-escape */
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { Box, CircularProgress } from "@mui/material";
import networkConfigServices from "../../services/networkConfigServices";
import useAuth from "../../Utils/useAuth";
import { ApiError, ErrorHandler } from "../../Utils/Constants.";
import PropTypes from "prop-types";

/**
//    * @component  Export Zone Network Excel Sheet  
//    * @description  Export file with zone and network details with mapped with respective zone by zoneId
//    * @returns Export Zone Network Excel Sheet details  UI
//    */

const ExportZoneNetworkExcelSheet = (props) => {
  const { bearerToken, localStorageData } = useAuth(); // context for authentication details
  const [loading, setLoading] = useState(false); // loading state for
  const [headerData, setHeaderData] = useState({}); // to set auth token in herder to fetch API

  useEffect(() => {
    let token =
      localStorageData !== null && localStorageData !== undefined
        ? localStorageData.authenticationToken.authToken
        : undefined;

    const header = {
      Authorization: `Bearer ${token ? token : bearerToken}`,
    };
    setHeaderData(header);
  }, [bearerToken, localStorageData]);

  // API calling function to fetch and download export file
  const exportZoneDetailSheet = async (zoneId) => {
    /** API integration */
    await networkConfigServices
      .downloadExcelSheet(zoneId, headerData)
      .then((response) => {
        props.setShowMsgComp(true);
        if (response && response.data) {
          if (response.data.httpStatusCode === 200) {
            const body = document.querySelector("body");
            const { fileContents, fileDownloadName, contentType } =
              response.data.apiResponse;
            const link = document.createElement("a");
            link.href = `data:${contentType};base64,${fileContents}`;
            link.target = "_blank";
            link.download = fileDownloadName;
            body.appendChild(link);
            link.click();
            link.remove();
            setLoading(false);
            props.setMsgContent({
              msg: "File exported successfully",
              type: "success",
            });
          } else {
            setLoading(false);
            props.setMsgContent(ApiError);
          }
        } else if (response.error) {
          setLoading(false);
          props.setMsgContent(ApiError);
        }
      })
      .catch((e) => {
        ErrorHandler(e);
        setLoading(false);
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className={`exportBtn ${props.exportDisable || loading ? "disableBtn" : ""}`}>
      {/* E5 design: outlined purple button with a download icon */}
      <Box
        component="button"
        type="button"
        aria-label="Export"
        disabled={loading}
        onClick={() => {
          // one download at a time
          if (loading) return;
          setLoading(true);
          exportZoneDetailSheet(props.id);
        }}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: "10px",
          height: 32,
          p: "0 14px 0 10px",
          fontSize: 12,
          fontWeight: 700,
          fontFamily: "inherit",
          cursor: "pointer",
          border: "1.5px solid #864797",
          backgroundColor: "#fff",
          color: "#864797",
          borderRadius: "6px",
          boxShadow: "0 1px 2px rgba(16,24,40,.06)",
          "&:hover": { backgroundColor: "#f4eef7" },
          "&:active": { transform: "scale(.98)" },
        }}
      >
        {loading ? (
          <CircularProgress size={16} sx={{ color: "#864797" }} />
        ) : (
          <FontAwesomeIcon icon={faDownload} style={{ fontSize: 12 }} />
        )}
        Export
      </Box>
    </div>
  );
};

ExportZoneNetworkExcelSheet.propTypes = {
  id: PropTypes.number,
  exportDisable: PropTypes.bool,
};

export default ExportZoneNetworkExcelSheet;
